<div class="profile-info">
  <div class="user">
    <div class="avatar border-linear">
      <img [src]="session.profile().avatar" />
    </div>
    <div class="user-info">
      <div class="name">
        {{ session.profile().name | name }} @if (false) {
        <span>#{{ session.profile().id || 1111 }}</span>
        }
      </div>
      <div class="user-status">
        <app-level-new [level]="session.profile().level" class="user-level badge badge_rounded badge_font-l badge-line-height"></app-level-new>
      </div>
    </div>
  </div>

  <!-- level -->
  <div class="level-info">
    <div class="level">
      <span class="current-level">
        {{ session.profile().level }}
      </span>
      <div class="level-progress">
        <span class="current-xp">{{ session.profile().xp }}</span> / <span class="needed-xp"> {{ session.profile().xpNeeded }}</span>
      </div>
      <span class="next-level">{{ session.profile().level + 1 }}</span>
    </div>
    <div class="xp-bar">
      <div class="bar-out">
        <div class="bar-in" [style.width.%]="(session.profile().xp / session.profile().xpNeeded) * 100" [style.background]="levelColor"></div>
      </div>
    </div>
  </div>
</div>

<div class="divider"></div>

<div class="discord-link profile-block">
  <span> {{ rewardsService.discord().joined && rewardsService.discord().linked ? 'Your Discord is linked to this profile' : 'Your discord is not linked to this profile' }}</span>
  <button class="black button link-button" (click)="rewardsService.authDiscord()" [disabled]="rewardsService.discord().joined && rewardsService.discord().linked">
    {{ rewardsService.discord().joined && rewardsService.discord().linked ? 'Unlink' : 'Link' }}
  </button>

  <svg
    class="discord-logo-bg"
    width="185px"
    height="185px"
    viewBox="-25.6 -25.6 307.20 307.20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid"
    fill="#171717"
    stroke="#171717"
    transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="1"></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <path
          d="M216.856339,16.5966031 C200.285002,8.84328665 182.566144,3.2084988 164.041564,0 C161.766523,4.11318106 159.108624,9.64549908 157.276099,14.0464379 C137.583995,11.0849896 118.072967,11.0849896 98.7430163,14.0464379 C96.9108417,9.64549908 94.1925838,4.11318106 91.8971895,0 C73.3526068,3.2084988 55.6133949,8.86399117 39.0420583,16.6376612 C5.61752293,67.146514 -3.4433191,116.400813 1.08711069,164.955721 C23.2560196,181.510915 44.7403634,191.567697 65.8621325,198.148576 C71.0772151,190.971126 75.7283628,183.341335 79.7352139,175.300261 C72.104019,172.400575 64.7949724,168.822202 57.8887866,164.667963 C59.7209612,163.310589 61.5131304,161.891452 63.2445898,160.431257 C105.36741,180.133187 151.134928,180.133187 192.754523,160.431257 C194.506336,161.891452 196.298154,163.310589 198.110326,164.667963 C191.183787,168.842556 183.854737,172.420929 176.223542,175.320965 C180.230393,183.341335 184.861538,190.991831 190.096624,198.16893 C211.238746,191.588051 232.743023,181.531619 254.911949,164.955721 C260.227747,108.668201 245.831087,59.8662432 216.856339,16.5966031 Z M85.4738752,135.09489 C72.8290281,135.09489 62.4592217,123.290155 62.4592217,108.914901 C62.4592217,94.5396472 72.607595,82.7145587 85.4738752,82.7145587 C98.3405064,82.7145587 108.709962,94.5189427 108.488529,108.914901 C108.508531,123.290155 98.3405064,135.09489 85.4738752,135.09489 Z M170.525237,135.09489 C157.88039,135.09489 147.510584,123.290155 147.510584,108.914901 C147.510584,94.5396472 157.658606,82.7145587 170.525237,82.7145587 C183.391518,82.7145587 193.761324,94.5189427 193.539891,108.914901 C193.539891,123.290155 183.391518,135.09489 170.525237,135.09489 Z"
          fill="#ffffff00"
          fill-rule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
</div>

<div class="steam-trade profile-block">
  <div class="text-with-icon">
    <h4 class="profile-block__subheading">Steam Trade URL</h4>
    <app-icon [width]="16" [icon]="'steam'"></app-icon>
  </div>
  <p>You can find your Steam trade URL <a href="https://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url" target="_blank">here</a></p>
  <div class="steam-trade-input">
    <div class="input-group black-third">
      <input type="text" [placeholder]="session?.stats?.trade_url ?? 'Steam trade URL'" [(ngModel)]="steamTradeUrl" />
    </div>
    <button class="button red" [disabled]="steamTradeUrl.length < 10" (click)="onSetTradeUrl()">Save</button>
  </div>
</div>

<div class="divider"></div>

<div class="stats">
  @for (mode of statsArray; track mode.name ) {
  <div class="stat-box profile-block">
    <div class="gamemode">
      <div class="title">{{ mode.name }} Statistics</div>
    </div>
    <div class="container">
      <div class="stat">
        <div class="title">Total</div>
        <div class="value-container">
          <app-icon [width]="16" [icon]="'coin'"></app-icon>
          <app-currency class="value decimal-white" [value]="mode.total" [size]="16" [animation]="false"></app-currency>
        </div>
      </div>
      <div class="stat-divider"></div>
      <div class="stat">
        <div class="title">Profit</div>
        <div class="value-container">
          <app-icon [width]="16" [icon]="'coin'"></app-icon>
          <app-currency class="value decimal-white" [value]="mode.profit" [size]="16" [animation]="false"></app-currency>
        </div>
      </div>
    </div>
  </div>
  }

  <div class="stat-box profile-block">
    <div class="gamemode">
      <div class="title">Deposits and Withdraws</div>
    </div>
    <div class="container large">
      <div class="large-stats__container">
        <div class="stat">
          <div class="title">Deposits</div>
          <div class="value-container">
            <app-icon [width]="16" [icon]="'coin'"></app-icon>
            <app-currency class="value decimal-white" [value]="stats.wallet.deposits" [size]="16" [animation]="false"></app-currency>
          </div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat">
          <div class="title">Withdraws</div>
          <div class="value-container">
            <app-icon [width]="16" [icon]="'coin'"></app-icon>
            <app-currency class="value decimal-white" [value]="stats.wallet.withdraws" [size]="16" [animation]="false"></app-currency>
          </div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat">
          <div class="title">Total</div>
          <div class="value-container">
            <app-icon [width]="16" [icon]="'coin'"></app-icon>
            <app-currency class="value decimal-white" [value]="stats.wallet.profit" [size]="16" [animation]="false"></app-currency>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
